import { render, staticRenderFns } from "./authorizeForm.vue?vue&type=template&id=f1e2c5ba"
import script from "./authorizeForm.vue?vue&type=script&lang=js"
export * from "./authorizeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports